module.exports = __webpack_public_path__ + "static/careers-e9811862b76f67a102077940bfa92c7b.mp4";